import format from 'date-fns/format/index.js'

export default function formatDate (date, pattern) {
  // date is a LocalDate instance
  if (date && typeof date.format == 'function') {
    return date.format(pattern)
  }

  // if the date to format is just a date string (no time component), or a
  // numerical date at precisely midnight (used in tests), then assume the
  // formatted result should not be automatically adjusted for local time zone
  let cancelSystemTimezoneOffset = (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)) ||
    (typeof date === 'number' && (new Date(date)).toISOString().endsWith('T00:00:00.000Z'))

  date = new Date(date)

  if (cancelSystemTimezoneOffset) {
    // adjust the hours by the timezone offset to ensure we get
    // the same date regardless of where this code is running
    date.setMinutes(date.getMinutes() + date.getTimezoneOffset())
  }

  return format(date, pattern)
}
